import { OmsLinkTypeV5 } from '../../apis/graphql';

export const OMS_LINK_TYPES_DO_NOT_NEED_TO_BE_VERIFIED: OmsLinkTypeV5[] = [
  OmsLinkTypeV5.DcmOrderLineItem,
  OmsLinkTypeV5.AcpLineItem,
];
